import Grid from '@mui/material/Grid';
import { ReactComponent as Close } from 'assets/icons/CloseFilter.svg';
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import InfoTooltip from 'components/InfoTooltip';
import { LabelField } from 'components/LabelField';
import { MyCheckbox } from 'components/MyCheckbox';
import addDays from "date-fns/addDays";
import { getDateFormat, getDateFormatForDatePicket } from 'helper/dateFormat';
import React from 'react';
import Select, { components } from "react-select";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { CloseButtonWrapper, FilterCloseButton, FilterColumn, FilterRows } from "./Theme";
import { filterList, predefinedRanges } from './YahrzeitFiltersData';
const selectControlStyles = {
  backgroundColor: "#FFFFFF",
  borderColor: "#FFFFFF",
  color: "#b5b5c3",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
};

const { beforeToday, allowedRange } = DateRangePicker;
const formatOptionLabel = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};




const YahrzeitFilters = ({ handleOpenFilters, openFilters, setOpenFilters, filterChange, yahrzeitFilter, date, setDate, setDateRange, startDate, endDate }) => {
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();
  const displayFilter = (filter) => {
    switch (filter.type) {
      case "select":
        return (
          <>
            <div className="d-flex align-items-center">
              <LabelField title={filter.label} />
              {filter.name === "languageType" && (
                <InfoTooltip text="Filters by whether the yahrzeit reminder date is calculated from the Hebrew or English date of death." style={{ marginLeft: '6px', marginBottom: '8px' }} />
              )}
            </div>
            <Select
              {...{
                name: filter.name,
              }}
              classNamePrefix="react-select"
              formatOptionLabel={formatOptionLabel}
              options={filter.list}
              styles={colourStyles}
              onChange={(value) => {
                filterChange(filter.name, value?.value);
              }}
              value={filter.list.find((item) => item.value === yahrzeitFilter?.[filter.name]) || null}
              components={{ DropdownIndicator }}
            />
          </>
        );
      case "checkbox":
        return (
          <MyCheckbox
            title={filter.label}
            checked={yahrzeitFilter?.[filter.name]}
            handlechange={() => {
              filterChange(filter.name, !yahrzeitFilter?.[filter.name]);
            }}
            titleStyles={{
              fontSize: "14px"
            }}
            style={{
              marginTop: "40px"
            }}
          />
        );
      default:
        return null;
    }
  };


  return (
    <>
      <CloseButtonWrapper>
        <FilterCloseButton onClick={() => setOpenFilters(!openFilters)} className="filter-button">
          <Close onClick={handleOpenFilters} />
        </FilterCloseButton>
      </CloseButtonWrapper>
      <FilterRows className="row">
        {filterList.map((filter) => (
          <FilterColumn className={` ${filter.className ? filter.className : "col-6 col-sm-4 col-md-3"}`} key={filter.name}>
            {displayFilter(filter)}
          </FilterColumn>
        ))}
        <FilterColumn className="col-6 col-sm-4 col-md-3">
          <div className="date-wrapper docu-date">
            <LabelField title={"Date Range"} />
            <div className="datepicker-containers">
              <DateRangePicker
                format={dateFormate}
                placeholder={`${placeholderFormat} - ${placeholderFormat}`}
                cleanable={true}
                style={{
                  display: "inline-block",
                  padding: "0",
                  border: "0",
                  width: "100%",
                  color: "black",
                }}
                size="lg"
                value={date}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                // disabledDate={beforeToday()}
                disabledDate={allowedRange(addDays(new Date(), -364), addDays(new Date(), 364))}
                ranges={predefinedRanges}
                onChange={(update) => {
                  setDateRange(update);
                  setDate(update);
                }}
              />
              {/* {startDate && endDate && (
                <div
                  style={{
                    position: "absolute",
                    top: "14px",
                    right: "-23px",
                    color: "#8080da",
                    cursor: "pointer",
                    zIndex: "999",
                  }}
                  onClick={() => {
                    setDateRange([null, null]);
                    setDate([]);
                  }}
                >
                  clear
                </div>
              )} */}
            </div>
          </div>
        </FilterColumn>
      </FilterRows>
    </>
  )
}

export default YahrzeitFilters